<script lang="ts">
	// Design system components
	import { Select } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	// Config
	import { getTempSchemeChartConfig } from './chart_config';
	import { getDailyRangeOptions, startsWeekOnSun } from 'src/helpers/date_helper';
	// Components
	import Chart from './Chart.svelte';
	//Types
	import type { ChartDataInterface } from '../../types/Chart';
	import type { IChartTempSchedule } from '../../types/TemperatureSchemeType';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let data: IChartTempSchedule;
	export let editMode: boolean = false;
	export let forceEnabled: boolean = false;

	const startWeekOnSun = startsWeekOnSun(),
		rangeOptions = getDailyRangeOptions(startWeekOnSun),
		onChangeRange = (range: number) => {
			rangeValue = rangeOptions.find((el) => el.value === range);
			chartData = getTempSchemeChartConfig(range, data, startWeekOnSun);
		},
		selectChangeRange = (e: CustomEvent | { detail: number }) => {
			onChangeRange(e.detail.value);
		},
		chartChangeRange = (e: CustomEvent) => {
			if (e.detail.action == 'dblClick' && rangeValue.value == -1) {
				e.preventDefault();
				e.stopPropagation();
				const day = new Date(e.detail.date).getDay();
				onChangeRange(day);
			}
		};

	let rangeValue = rangeOptions[0],
		chartData: ChartDataInterface;

	$: chartData = getTempSchemeChartConfig(rangeValue.value, data, startWeekOnSun);
</script>

<div class="d-flex">
	<Select
		id="select-temp-scheme-chart-range"
		aria-label={$format('select_temp_scheme_chart_range', {
			default: 'Select temperature scheme chart range',
		})}
		class={classMap({ 'mb-m': $showNewLayout })}
		disabled={editMode}
		value={rangeValue}
		size="m"
		icon="fas fa-clock-rotate-left"
		options={rangeOptions}
		on:change={selectChangeRange}
		on:click={(e) => {
			e.preventDefault();
			e.stopPropagation();
			return;
		}}
	/>
</div>
<Chart
	hideTooltip={editMode}
	chartData={forceEnabled ? { ...chartData, disabled: false } : chartData}
	on:change={chartChangeRange}
/>
